import { InvalidScheduledBlocksAssignment } from "@models/ISchema";

// CHS-2785 / EDH-014 (backend code VALIDATE_EXCEEDED_SCHEDULED_BLOCKS, PR
// Foris/darwined#5420). Kept as a named constant (rather than a literal in every
// switch/case) so the single source of truth stays here if it ever changes.
export const SCHEDULED_BLOCKS_ASSIGNMENT_TYPENAME: InvalidScheduledBlocksAssignment["__typename"] =
  "InvalidScheduledBlocksAssignment";

export interface ScheduledBlocksAssignmentPayload {
  sectionCode: string;
  planned: number | string;
  assigned: number | string;
  exceeded: number | string;
}

export const mapScheduledBlocksAssignmentPayload = (
  incidence: Partial<InvalidScheduledBlocksAssignment>,
): ScheduledBlocksAssignmentPayload => {
  const section = incidence?.section;
  // section is optional on the type (defensive: keep working even if a given error
  // instance omits it), so the code prefix stays conditional at render time.
  const componentCode = section?.component?.code ?? section?.courseComponent?.component?.code ?? "";
  const sectionCode = [componentCode, section?.code].filter(Boolean).join(" ");

  return {
    sectionCode,
    planned: incidence?.plannedBlocks ?? "-",
    assigned: incidence?.assignedBlocks ?? "-",
    exceeded: incidence?.exceededBlocks ?? "-",
  };
};
